/**
 * 角色权限
 */

import {
  get,
  post,
  put,
  del
} from '@/util/request'

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectRolePermissionById = (Id) => {
  return get('/api/app/RolePermission?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddRolePermission = (data) => {
  return post('/api/app/RolePermission', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyRolePermission = (data) => {
  return put('/api/app/RolePermission', data, {});
}

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDataRolePermissionList = (data) => {
  return post('/api/app/RolePermission/list', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteRolePermission = (id) => {
  return del('/api/app/RolePermission/' + id, {}, {});
}

/**
 * 权限设置
 * @param {*} data
 * @returns
 */
export const AddRolePermissions = (id, data) => {
  return post('/api/app/rolePermission/rolePermissions/' + id, data, {});
}